import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import CustomNavbar from "./Navbar";
import "./3DModeling.css";

// Video data
const videoUrls = ["/video/Plantlayout.mp4", "/video/rooster.mp4"];
const videoTitles = [
  "3D Modelling of overall Iron ore beneficary",
  "Overall 3D modeling of chemical Plant",
];

// Image data organized by category
const blastFurnaceImages = [
  {
    src: "/3d/bf/BF 1.jpg",
    name: "Blast furnace 3D modeling",
    keywords:
      "steel plant 3D model, industrial furnace design, metallurgical plant visualization",
  },
  {
    src: "/3d/bf/BF 5.jpg",
    name: "Detail furnace 3D modeling",
    keywords:
      "furnace 3D rendering, steel production modeling, industrial equipment visualization",
  },
  {
    src: "/3d/bf/BF 3.jpg",
    name: "Detail Pumphouse 3D Modelling",
    keywords:
      "furnace interior design, steel manufacturing model, plant layout visualization",
  },
];

const smpImages = [
  {
    src: "/3d/smp/S4.jpg",
    name: "Detailed Piping of 3D Modelling ",
    keywords: "SMS plant design, steel workshop 3D, melting shop visualization",
  },
  {
    src: "/3d/smp/S5.jpg",
    name: "Inter Plant Piping ",
    keywords:
      "metal processing model, steel plant equipment, industrial 3D rendering",
  },
  {
    src: "/3d/smp/S6.jpg",
    name: "SMS Outdoor Piping",
    keywords:
      "plant control cInter 3D, industrial automation model, steel plant monitoring",
  },
];

const plantImages = [
  {
    src: "/3d/plantdesign/B1.jpg",
    name: "3D master model of plant showing piping, structure, and equipment integration",
    keywords:
      "EPC plant design, industrial facility 3D, complete plant modeling",
  },
  {
    src: "/3d/plantdesign/RD/R2.jpg",
    name: "3D-rendered plant utility corridor with electrical, piping, and HVAC systems",
    keywords:
      "industrial road layout, plant infrastructure 3D, facility access modeling",
  },
  {
    src: "/3d/plantdesign/B7.jpg",
    name: "3D model of integrated plant showing blast furnace, SMS, and rolling mill",
    keywords:
      "factory building design, industrial architecture 3D, plant structure modeling",
  },
];

const buildingImages = [
  {
    src: "/3d/Structuralbuilding/CRM BAY BUILDING.jpg",
    name: "CRM BAY Building",
    keywords:
      "steel structure building, industrial construction 3D, plant facility modeling",
  },
  {
    src: "/3d/Structuralbuilding/MRSS BUILDING.jpg",
    name: "MRSS Building",
    keywords:
      "structural steel design, building framework 3D, industrial architecture",
  },
  {
    src: "/3d/Structuralbuilding/1.jpg",
    name: "High-rise office building ",
    keywords:
      "industrial interior design, building components 3D, structural detailing",
  },
];

const pilingImages = [
  {
    src: "/3d/pf/PF1.jpg",
    name: "3D Modeling of Foundation Design",
    keywords:
      "foundation piling design, construction piling 3D, structural foundation modeling",
  },
  {
    src: "/3d/pf/PF2.jpg",
    name: "Deep Piling BIM Modeling",
    keywords:
      "deep foundation 3D, pile cap design, structural support modeling",
  },
  {
    src: "/3d/pf/PF3.jpg",
    name: "3D Modeling in Pile and Pile-Cap",
    keywords:
      "pile foundation rendering, construction support design, underground structure 3D",
  },
];

const architecturalImages = [
  {
    src: "/3d/articurtural/1.jpg",
    name: "Industrial Administrative Office Building Design",
    keywords:
      "plant architecture 3D, industrial facility design, BIM architectural modeling",
  },
  {
    src: "/3d/articurtural/2.jpg",
    name: "High-Rise Apartment Facade Architectural Design",
    keywords:
      "building exterior rendering, facade design 3D, industrial aesthetics modeling",
  },
  {
    src: "/3d/articurtural/3.jpg",
    name: "Institutional Building with Interior Architectural Design",
    keywords:
      "industrial interior architecture, space planning 3D, functional design modeling",
  },
];

const equipmentImages = [
  {
    src: "/3d/equip/M1.jpg",
    name: "Belt Conveyor ",
    keywords:
      "plant machinery 3D, heavy equipment design, industrial component modeling",
  },
  {
    src: "/3d/equip/M2.jpg",
    name: "Crusher Machine Model",
    keywords:
      "mechanical equipment rendering, industrial machine design, engineering components 3D",
  },
  {
    src: "/3d/equip/M3.jpg",
    name: "Vibrating Screen Model",
    keywords:
      "mechanical design 3D, equipment assembly model, industrial part visualization",
  },
];

const electricalImages = [
  {
    src: "/3d/electrical/E6.png",
    name: "Overall Plant Cable Tray Layout ",
    keywords:
      "plant electrical design, power distribution 3D, industrial wiring modeling",
  },
  {
    src: "/3d/electrical/E7.png",
    name: "Electrical Pump House Layout",
    keywords:
      "control panel 3D, electrical cabinet modeling, industrial wiring layout",
  },
  {
    src: "/3d/electrical/E1.jpg",
    name: "Electrical Tray Detail",
    keywords:
      "industrial electrical components, wiring harness design, power system visualization",
  },
];

const pipingImages = [
  {
    src: "/3d/piping/Roaster 1.png",
    name: " Piping System of Blast Furnace",
    keywords:
      "plant piping design, process piping 3D, industrial pipeline modeling",
  },
  {
    src: "/3d/piping/Roaster 2.png",
    name: "Process water of Pump House",
    keywords:
      "pipe routing design, fluid system modeling, industrial plumbing 3D",
  },
  {
    src: "/3d/piping/Roaster 3.png",
    name: "Process Piping of BF-2 ",
    keywords:
      "pipe fitting 3D, flange connection design, industrial joint modeling",
  },
];

const teklaImages = [
  {
    src: "/3d/tekla/model/2.png",
    name: "Tekla Steel Structure Model",
    keywords:
      "Tekla Structures design, steel detailing 3D, BIM structural modeling",
  },
  {
    src: "/3d/tekla/conn/3.png",
    name: "Tekla Connection Detail",
    keywords:
      "steel connection design, Tekla fabrication model, structural joint detailing",
  },
  {
    src: "/3d/tekla/1.png",
    name: "Tekla Detailed Conveyer Gallery",
    keywords:
      "steel fabrication drawings, Tekla BIM model, construction documentation",
  },
];

const bimImages = [
  {
    src: "/3d/tekla/model/2.png",
    name: "BIM LOD 400 Structural Model",
    keywords:
      "BIM structural modeling, LOD 400 design, construction documentation",
  },
  {
    src: "/3d/BIM/2.png",
    name: "Parametric BIM Model",
    keywords: "clash detection, MEP coordination, integrated BIM model",
  },
  {
    src: "/3d/Structuralbuilding/MRSS BUILDING.jpg",
    name: "BIM for Civil Structures",
    keywords: "4D scheduling, construction planning, BIM timeline",
  },
];

// Components with enhanced SEO attributes
const ImageCard = ({ src, alt, keywords }) => (
  <div className="image-card-container">
    <Card className="image-card h-100">
      <div className="image-card-inner">
        <Card.Img
          variant="top"
          src={src}
          alt={alt}
          title={keywords}
          className="image-card-img"
          loading="lazy"
        />
      </div>
      <Card.Body>
        <Card.Title style={{ color: "#000000" }}>{alt}</Card.Title>
        <meta name="keywords" content={keywords} />
      </Card.Body>
    </Card>
  </div>
);

const ImageGrid = ({ title, images }) => (
  <div className="image-grid-section my-5">
    <h3 className="section-title mb-4">
      <span className="title-decoration">{title}</span>
    </h3>
    <Row className="g-4">
      {images.map((image, idx) => (
        <Col key={idx} lg={4} md={6} className="image-col">
          <ImageCard
            src={image.src}
            alt={image.name}
            keywords={image.keywords}
          />
        </Col>
      ))}
    </Row>
  </div>
);

const VideoCard = ({ url, title }) => {
  const videoKeywords = title.includes("Plant")
    ? "3D plant layout visualization, industrial facility tour, EPC project showcase"
    : "blast furnace 3D animation, steel production visualization, metallurgical plant tour";

  return (
    <div className="video-card-container">
      <div className="video-card">
        <div className="video-wrapper">
          <video
            src={url}
            title={title}
            aria-label={`Video demonstration of ${title}`}
            muted
            controls
            controlsList="nodownload"
            playsInline
            style={{ width: "100%", borderRadius: "12px" }}
            preload="metadata"
          />
        </div>
        <div className="video-caption">
          {title}
          <meta name="keywords" content={videoKeywords} />
        </div>
      </div>
    </div>
  );
};

const VideoRow = () => (
  <Row className="video-row g-4 my-5">
    {videoUrls.map((url, idx) => (
      <Col key={idx} lg={6} md={12}>
        <VideoCard
          url={url}
          title={videoTitles[idx] || `3D Modeling Showcase ${idx + 1}`}
        />
      </Col>
    ))}
  </Row>
);

const ThreeDModeling = () => {
  const pageKeywords =
    "3D modeling services, industrial plant design, BIM modeling, steel plant visualization, EPC project modeling, Tekla Structures design, plant layout 3D, structural engineering models";

  return (
    <>
      <CustomNavbar />
      <div className="modern-bg">
        <Container className="py-4">
          {/* SEO Meta tags in the head would be added in your layout component */}

          <section className="hero-section text-cInter mb-4">
            <h1 className="display-4 fw-bold mb-3">
              <span className="gradient-text">
                  Industrial 3D Modeling & BIM Services
              </span>
            </h1>
            {/* <p className="lead mb-4" style={{ color: "#212529" }}>
              NAEW provides comprehensive 3D modeling and BIM solutions for EPC
              projects across all disciplines including Civil, Architectural,
              Structural, Electrical, Piping, and Equipment design for complete
              plant visualization.
              <br />
              Our BIM-enabled 3D models with varying LOD (Level of Detail) are
              optimized for project monitoring and clash detection.
            </p> */}
            <meta name="keywords" content={pageKeywords} />
          </section>

          <section className="video-showcase mb-5">
            <h2 className="section-header mb-4">
              <span style={{ color: "#212529" }}>3D Project Showcase</span>
            </h2>
            <VideoRow />
          </section>

          {/* Tekla Structures Section */}
          <section className="tekla-section mb-5">
            <h2 className="section-header mb-4">
              <span style={{ color: "#212529" }}>Tekla Structures Design</span>
            </h2>
            <ImageGrid title="Tekla Structures Modeling" images={teklaImages} />
          </section>

          <section className="industrial-section mb-5">
            <h2 className="section-header mb-4">
              <span style={{ color: "#212529" }}>
                Industrial Plant Modeling
              </span>
            </h2>
            <ImageGrid title="Blast Furnace (BF)" images={blastFurnaceImages} />
            <ImageGrid title="Steel Melting Shop (SMS)" images={smpImages} />
            <ImageGrid title="Complete Plant Design" images={plantImages} />
          </section>

          <section className="civil-section mb-5">
            <h2 className="section-header mb-4">
              <span style={{ color: "#212529" }}>
                Civil & Architectural Modeling
              </span>
            </h2>
            <ImageGrid
              title="Structural Building Design"
              images={buildingImages}
            />
            <ImageGrid
              title="Piling & Foundation Systems"
              images={pilingImages}
            />
            <ImageGrid
              title="Architectural Visualization"
              images={architecturalImages}
            />
          </section>

          <section className="structural-section mb-5">
            <h2 className="section-header mb-4">
              <span style={{ color: "#212529" }}>
                Engineering Systems Modeling
              </span>
            </h2>
            <ImageGrid
              title="Industrial Equipment Models"
              images={equipmentImages}
            />
            <ImageGrid
              title="Electrical Systems Design"
              images={electricalImages}
            />
            <ImageGrid title="Piping & Process Systems" images={pipingImages} />
          </section>

          <section className="bim-section mb-5">
            <h2 className="section-header mb-4">
              <span style={{ color: "#212529" }}>
                Building Information Modeling (BIM)
              </span>
            </h2>
            <ImageGrid
              title="BIM Development & Coordination"
              images={bimImages}
            />
          </section>

          <section className="cta-section text-cInter py-5 my-5 rounded-4">
            <h2 className="mb-4" style={{ color: "#212529" }}>
              Transform Your Project with Advanced 3D Modeling
            </h2>
            <p className="mb-4" style={{ color: "#212529" }}>
              Our BIM and 3D modeling experts are ready to convert your concepts
              into precise, constructible digital models for your industrial
              projects.
            </p>
            <button className="btn btn-primary btn-lg px-5">
              Request Project Consultation
            </button>
            <meta
              name="keywords"
              content="3D modeling consultation, BIM services quote, industrial design experts"
            />
          </section>
        </Container>
      </div>
    </>
  );
};

export default ThreeDModeling;
